export default __webpack_public_path__ + "static/service-menu-casestudy-49929264c14569764429a47156735893.jpg";